module.exports = __webpack_public_path__ + "img/medMission_041022_C.d7e404f7.jpg";